import './AppSidebar.css';

import React, { useState } from 'react'
import { Offcanvas, Nav } from 'react-bootstrap'
import { Link, useLocation } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro'
import classNames from 'classnames';
import { useEffect } from 'react';
import { EventEmitter } from '../../utils/EventEmitter';
import { useAuth } from '../../contexts/auth';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

const NAVIGATION_MENU: NavigationLink[] = [
  { key: 'dashboard', icon: solid('gauge'), title: 'Dashboard', url: '/dashboard', hide: window.__env.HIDE_DASHBOARD },
  { key: 'datasources', icon: solid('faucet-drip'), title: 'Data Sources', url: '/datasources', hide: window.__env.HIDE_DATASOURCES },
  { key: 'datasets', icon: solid('database'), title: window.__env.NAVIGATION_DATASETS_TITLE || 'Datasets', url: '/datasets', hide: window.__env.HIDE_DATASETS },
  { key: 'models', icon: solid('graduation-cap'), title: window.__env.NAVIGATION_MODELS_TITLE || 'AI/ML Models', url: '/models', hide: window.__env.HIDE_MODELS },
  { key: 'services', icon: solid('cubes'), title: window.__env.NAVIGATION_SERVICES_TITLE || 'BDA Services', url: '/services', hide: window.__env.HIDE_SERVICES },
  { key: 'applications', icon: solid('laptop-code'), title: window.__env.NAVIGATION_APPLICATIONS_TITLE || 'BDA Applications', url: '/bda-applications', hide: window.__env.HIDE_APPLICATIONS },
  { key: 'projects', icon: solid('folder'), title: 'Projects', url: '/projects', hide: window.__env.HIDE_PROJECTS },
  { key: 'visualization', icon: solid('chart-bar'), title: 'Visualization', url: '/visualization', hide: window.__env.HIDE_VISUALIZATION },
  { key: 'control-panel', icon: solid('server'), title: 'Control Panel', url: '/control-panel', admin: true },
]

type NavigationLink = {
  key: string;
  icon: IconDefinition;
  title: string;
  url: string;
  hide?: boolean;
  admin?: boolean;
}

type LinkProps = {
  link: NavigationLink;
}

function SidebarLink({ link }: LinkProps) {
  const location = useLocation();
  const match = location.pathname.startsWith(link.url);

  return (
    <Link className={classNames("sidebar-link", { active: match })} to={link.url}>
      <FontAwesomeIcon icon={link.icon} fixedWidth={true} />
      <span className="ms-3">{link.title}</span>
    </Link>
  );
}

type Props = {
  show: boolean;
  handleClose: VoidFunction;
}

function AppSidebar({ show, handleClose }: Props) {
  const [timestamp, setTimestamp] = useState(new Date().getTime());
  const location = useLocation();
  const { loggedUser } = useAuth();

  // eslint-disable-next-line
  useEffect(() => handleClose(), [location.pathname]);

  useEffect(() => {
    EventEmitter.subscribe('update-timestamp', (ts: number) => setTimestamp(ts));
  }, []);

  return (
    <Offcanvas show={show} onHide={handleClose}>
      <div className="alida-sidebar" style={{ backgroundImage: `url(${window.__env.SIDEBAR_BG_IMAGE}?t=${timestamp})` }}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            {/* some optional title here */}
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="sidebar-content">
          <Nav defaultActiveKey="/" className="flex-column">
            {NAVIGATION_MENU
              .filter(link => !link.hide)
              .filter(link => !link.admin || loggedUser?.realmAdmin)
              .map(link => (
                <SidebarLink key={link.key} link={link} />
              ))}
            <a href="http://docs.alidalab.it" target="_blank" rel="noopener noreferrer" className="sidebar-link">
              <FontAwesomeIcon icon={solid('question-circle')} fixedWidth />
              <span className="ms-3">Documentation</span>
            </a>
          </Nav>
        </Offcanvas.Body>
      </div>
    </Offcanvas>
  )
}

export default AppSidebar
